import { updateOrderSnapshot } from '@/entities/order';
import { Alert, type AlertProps } from '@/shared/components/Alert';
import { DrawerBottomFixed, DrawerButton } from '@/shared/components/Drawer';
import { useAsyncFn } from '@/shared/lib/hooks';

type OutdatedDeliveryPricesModalProps = AlertProps & {
    orderId: string;
    signature: string;
    storeSlug: string;
};

export const OutdatedDeliveryPricesModal = (props: OutdatedDeliveryPricesModalProps) => {
    const { signature, orderId, storeSlug, ...other } = props;
    const [{ loading, error }, onUpdateSnapshot] = useAsyncFn(async () => {
        await updateOrderSnapshot({ order_id: orderId, signature, store_slug: storeSlug });
        window.location.reload();
    }, [signature, orderId]);

    return (
        <Alert
            {...other}
            title="Цены на доставку изменились"
            description="Пока проходило оформление заказа, цены на доставку изменились. Обновите страницу, чтобы увидеть актуальные цены"
            button={
                <DrawerBottomFixed>
                    <DrawerButton isDisabled={loading} onClick={onUpdateSnapshot}>
                        Обновить
                    </DrawerButton>
                </DrawerBottomFixed>
            }
            errorText={error && 'Не удалось обновить цены. Попробуйте позже'}
        />
    );
};
